import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    clickHandler() {
      this.$emit('click')
    }
  },

  render
}
